module.exports = __webpack_public_path__ + "img/consultation.587c0a3c.svg";